// @flow
import type {SagaIterator} from 'redux-saga';

import {fork} from 'redux-saga/effects';

import {mktgEmail} from './marketingEmail';

/**
 * Google Tag Manager root saga.
 */
export default function* GTMSaga(): SagaIterator {
    yield fork(mktgEmail);
}
